package org.lennycodes.hldi.backend.db_service

import kotlinx.coroutines.await
import org.lennycodes.hldi.backend.FirebaseService
import org.lennycodes.hldi.backend.createUserWithEmailAndPassword

suspend fun register(
    email: String,
    password: String
): Boolean {

    return try {

        createUserWithEmailAndPassword(
            FirebaseService.auth,
            email,
            password
        ).await()


        console.log("Firebase registration successful")

        true


    } catch(e:Throwable){

        console.error(
            "Firebase registration failed: ${e.message}"
        )

        false

    }

}